import { BackgroundClasses_BoxDecorationBreak_$ctor_Z207A3CFB, BackgroundClasses_Isolation_$ctor_Z207A3CFB, BackgroundClasses_BackgroundBlendMode_$ctor_Z207A3CFB, BackgroundClasses_BackgroundPosition_$ctor_Z207A3CFB, BackgroundClasses_BackgroundImage_$ctor_Z207A3CFB, BackgroundClasses_BackgroundColor_$ctor_Z207A3CFB, BackgroundClasses_BackgroundAttachment_$ctor_Z207A3CFB, BackgroundClasses_BackgroundSize_$ctor_Z207A3CFB, BackgroundClasses_BackgroundRepeat_$ctor_Z207A3CFB, BackgroundClasses_BackgroundOrigin_$ctor_Z207A3CFB, BackgroundClasses_BackgroundClip_$ctor_Z207A3CFB } from "../Types/Background.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const BackgroundClip = BackgroundClasses_BackgroundClip_$ctor_Z207A3CFB(new Property_CssProperty(17));

export const BackgroundOrigin = BackgroundClasses_BackgroundOrigin_$ctor_Z207A3CFB(new Property_CssProperty(20));

export const BackgroundRepeat = BackgroundClasses_BackgroundRepeat_$ctor_Z207A3CFB(new Property_CssProperty(22));

export const BackgroundSize = BackgroundClasses_BackgroundSize_$ctor_Z207A3CFB(new Property_CssProperty(23));

export const BackgroundAttachment = BackgroundClasses_BackgroundAttachment_$ctor_Z207A3CFB(new Property_CssProperty(15));

export const BackgroundColor = BackgroundClasses_BackgroundColor_$ctor_Z207A3CFB(new Property_CssProperty(18));

export const BackgroundImage = BackgroundClasses_BackgroundImage_$ctor_Z207A3CFB(new Property_CssProperty(19));

export const BackgroundPosition = BackgroundClasses_BackgroundPosition_$ctor_Z207A3CFB(new Property_CssProperty(21));

export const BackgroundBlendMode = BackgroundClasses_BackgroundBlendMode_$ctor_Z207A3CFB(new Property_CssProperty(16));

export const Isolation = BackgroundClasses_Isolation_$ctor_Z207A3CFB(new Property_CssProperty(146));

export const BoxDecorationBreak = BackgroundClasses_BoxDecorationBreak_$ctor_Z207A3CFB(new Property_CssProperty(61));

